import { z } from 'zod';

import { isEmpty } from '@hsp/utilities';

import { DashboardTabs } from 'types/pages/audience-builder/dashboard/tabs.enum';
import { s } from 'utilities';

export const CloneSchema = z
  .object({
    name: z.string().trim().nonempty(s('Site.Pages.AudienceBuilder.Dashboard.Messages.Clone.AudienceName')),
    orderNumber: z.string().trim().optional(),
    tab: z.number(),
  })
  .superRefine((data, context) => {
    if (data.tab === DashboardTabs.Active && isEmpty(data.orderNumber)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: s('Site.Pages.AudienceBuilder.Dashboard.Messages.Clone.OrderNumber'),
        path: ['orderNumber'],
      });
    }
  });
export type CloneAudienceForm = z.infer<typeof CloneSchema>;
